export const API_ROOT = `${process.env.REACT_APP_API_ROOT}`;
export const API_ROOT_MEDS = `${process.env.REACT_APP_API_ROOT_MEDS}`;
